import * as layout from "../../routes/$layout.js";

const components = [
	() => import("../../routes/index.js"),
	() => import("../../routes/projects/$layout.js"),
	() => import("../../routes/projects/index.js"),
	() => import("../../routes/contact.js"),
	() => import("../../routes/canvas/$layout.js"),
	() => import("../../routes/canvas/index.js"),
	() => import("../../routes/canvas/editor.js"),
	() => import("../../routes/canvas/shell.js"),
	() => import("../../routes/canvas/wasm/index.js"),
	() => import("../../routes/about/index.js"),
	() => import("../../routes/about/workspace.js"),
	() => import("../../routes/about/music.js"),
	() => import("../../routes/blog/$layout.js"),
	() => import("../../routes/blog/index.js"),
	() => import("../../routes/blog/[post].js"),
	() => import("../../routes/blog/[...post].js"),
	() => import("../../routes/wasm.js")
];

export const pages = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			[components[0]]
		]
	},

	{
		// projects/index.svelte
		pattern: /^\/projects\/?$/,
		parts: [
			[components[1]],
	[components[2]]
		]
	},

	{
		// contact.svelte
		pattern: /^\/contact\/?$/,
		parts: [
			[components[3]]
		]
	},

	{
		// canvas/index.svelte
		pattern: /^\/canvas\/?$/,
		parts: [
			[components[4]],
	[components[5]]
		]
	},

	{
		// canvas/editor.svelte
		pattern: /^\/canvas\/editor\/?$/,
		parts: [
			[components[4]],
	[components[6]]
		]
	},

	{
		// canvas/shell.svelte
		pattern: /^\/canvas\/shell\/?$/,
		parts: [
			[components[4]],
	[components[7]]
		]
	},

	{
		// canvas/wasm/index.svelte
		pattern: /^\/canvas\/wasm\/?$/,
		parts: [
			[components[4]],
	[components[8]]
		]
	},

	{
		// about/index.svelte
		pattern: /^\/about\/?$/,
		parts: [
			[components[9]]
		]
	},

	{
		// about/workspace.svelte
		pattern: /^\/about\/workspace\/?$/,
		parts: [
			[components[10]]
		]
	},

	{
		// about/music.svelte
		pattern: /^\/about\/music\/?$/,
		parts: [
			[components[11]]
		]
	},

	{
		// blog/index.svelte
		pattern: /^\/blog\/?$/,
		parts: [
			[components[12]],
	[components[13]]
		]
	},

	{
		// blog/[post].svelte
		pattern: /^\/blog\/([^/]+?)\/?$/,
		parts: [
			[components[12]],
	[components[14], m => ({ post: d(m[1]) })]
		]
	},

	{
		// blog/[...post].svelte
		pattern: /^\/blog\/(.+)\/?$/,
		parts: [
			[components[12]],
	[components[15], m => ({ post: d(m[1]).split('/') })]
		]
	},

	{
		// wasm.svelte
		pattern: /^\/wasm\/?$/,
		parts: [
			[components[16]]
		]
	}
])(decodeURIComponent);

export const ignore = [
	
];

export { layout };